import axios from "../../../lib/axios";
import { AxiosResponse } from "axios";
import { IReview, ReviewFormValues } from "../../../types/api/review";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { QData } from "../../../types/basic-type-list";

export async function listReviews(
  qData?: QData
): Promise<AxiosResponse<TResponseWithQData<IReview[]>>> {
  return axios.get<TResponseWithQData<IReview[]>>("/review", {
    params: qData,
  });
}

export async function createReview(
  data: ReviewFormValues
): Promise<AxiosResponse<TResponse<IReview>>> {
  return axios.post<TResponse<IReview>>("/review", data);
}

export async function updateReview({
  id,
  data,
}: {
  id: string;
  data: Partial<ReviewFormValues>;
}): Promise<AxiosResponse<TResponse<IReview>>> {
  return axios.put<TResponse<IReview>>(`/review/${id}`, data);
}

export async function deleteReview(
  id: string
): Promise<AxiosResponse<TResponse<IReview>>> {
  return axios.delete<TResponse<IReview>>(`/review/${id}`);
}

export async function getReviewDetail(
  id: string
): Promise<AxiosResponse<TResponse<IReview>>> {
  return axios.get<TResponse<IReview>>(`/review/${id}`);
}
